import { css, type Theme } from "@emotion/react";

export const container = css`
  margin-bottom: 2rem;
`;

export const checkIcon = (theme: Theme) => css`
  color: ${theme.success.borderBase};
  width: 1rem;
`;

export const featureItem = css`
  margin-bottom: 0.25rem;
  margin-left: 0.5rem;
`;

export const availabilityNote = css`
  margin-left: 0.25rem;
  gap: 0.25rem;
`;
